import React, { FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { useSendMessageMutation } from '../../message/message.service';
import { isFetchBaseQueryError } from '../../../utils/helpers';
import cls from './SendMessage.module.scss';
import { RiSendPlane2Line } from 'react-icons/ri';

type initialValues = {
  text: string;
};

type SendMessageFormProps = {
  consumerId: string | undefined;
};

const SendMessageForm: FC<SendMessageFormProps> = ({ consumerId }) => {
  const [sendMessage] = useSendMessageMutation();
  const initialValues: initialValues = {
    text: '',
  };
  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { resetForm }) => {
      try {
        // the mutation invalidates the `Messages` tag, so the chat refetches itself
        await sendMessage({ consumerId: consumerId as string, text: values.text }).unwrap();
        resetForm();
      } catch (error) {
        if (isFetchBaseQueryError(error)) {
          console.log(error.status);
        }
      }
    },
  });
  return (
    <Form data-testid="send-form" onSubmit={formik.handleSubmit} className={cls.Form}>
      <Form.Control
        type="text"
        placeholder="Message"
        name="text"
        id="text"
        value={formik.values.text}
        onChange={formik.handleChange}
        className={cls.Input}
      />
      {formik.values.text.length !== 0 && (
        <Button type="submit" className={cls.Button}>
          <RiSendPlane2Line size="1.5rem" fill="currentColor" />
        </Button>
      )}
    </Form>
  );
};

export default SendMessageForm;
